import { BrandPromiseLine } from 'Components/lines/brand-promise-line/BrandPromiseLine';
export default BrandPromiseLine;
